import { parseInboundPayload } from '../inbound';
import { booleanParser, createArrayWithBracesParser, encodedStringParser, numberParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
const powerPlayerProductPartDefinitions = [
    { name: 'numMonthsPowerPlayer', parser: numberParser },
    { name: 'numJacksCost', parser: numberParser },
    { name: 'numAmmo', parser: numberParser },
    { name: 'productCode', parser: stringParser }
];
function powerPlayerProductParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, powerPlayerProductPartDefinitions);
}
export const SHOW_POWER_PLAYER_UPGRADE_WINDOW_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'isPowerPlayer', parser: booleanParser },
        { name: 'expirationDateString', parser: encodedStringParser },
        { name: 'allowUpgradeHere', parser: booleanParser },
        { name: 'powerPlayerProducts', parser: createArrayWithBracesParser(powerPlayerProductParser) },
        { name: 'pageName', parser: encodedStringParser },
        { name: 'givePowerPlayerConfirmPlayerId', parser: numberParser },
        { name: 'givePowerPlayerConfirmUsername', parser: encodedStringParser },
        { name: 'giveDefaultUsername', parser: encodedStringParser }
    ]
};
